import { UIRouter, Ng2StateDeclaration, Transition } from '@uirouter/angular';

import { CheckoutComponent } from './checkout.component';
import { CheckoutIndexComponent } from './index/index.component';
import { CheckoutRegisterComponent } from './register/register.component';
import { CheckoutPaymentComponent } from './payment/payment.component';
import { CheckoutSuccessComponent } from './success/success.component';
import { resolveStateParams } from '../global/resolves/params.resolve';
import { CheckoutSuccessVouchersComponent } from './successVouchers/successVouchers.component';

export let STATES: Ng2StateDeclaration[] = [
  {
    name: 'main.checkout',
    url: '/checkout?code',
    abstract: true,
    views: {
      '$default@': {component: CheckoutComponent}
    },
    redirectTo: 'checkout.index',
    resolve: [
      resolveStateParams
    ]
  },
  {
    name: 'main.checkout.index',
    url: '',
    views: {
      'content@main.checkout': {component: CheckoutIndexComponent}
    },
    params: {
      header: {
        hideCheckoutButton: true
      }
    }
  },
  {
    name: 'main.checkout.register',
    url: '/register',
    views: {
      'content@main.checkout': {component: CheckoutRegisterComponent}
    },
    params: {
      header: {
        hideCheckoutButton: true
      }
    }
  },
  {
    name: 'main.checkout.payment',
    url: '/payment',
    views: {
      'content@main.checkout': {component: CheckoutPaymentComponent}
    },
    params: {
      header: {
        hideCheckoutButton: true
      }
    }
  },
  {
    name: 'main.checkout.success',
    url: '/success',
    views: {
      'content@main.checkout': {component: CheckoutSuccessComponent}
    },
    params: {
      code: null,
      success: null,
      isNewUser: null,
      wasLoggedIn: null,
      buttonCount: null,
      onlyGifts: null,
      header: {
        hideCheckoutButton: true,
        backTo: 'main.checkout.index'
      }
    },
    resolve: [
      resolveStateParams
    ]
  },
  {
    name: 'main.checkout.successVouchers',
    url: '/success-vouchers',
    views: {
      'content@main.checkout': {component: CheckoutSuccessVouchersComponent}
    },
    params: {
      code: null,
      success: null,
      isNewUser: null,
      wasLoggedIn: null,
      buttonCount: null,
      onlyGifts: null,
      header: {
        hideCheckoutButton: true,
        backTo: 'main.checkout.index'
      }
    },
    resolve: [
      resolveStateParams
    ]
  }
];


// WEBPACK FOOTER //
// ./src/app/checkout/checkout.states.ts